/**
 * @generated SignedSource<<5fea28a622debb1175a7f8409f0f362d>>
 * @relayHash 044d266abdac3b8465cb51ea5db11fb8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a3949ed12b6ced04d34d02559d4db8de81e4d4cca0d32e35e9563ea54bb23de5

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type ConfluenceLength = "LONG" | "MEDIUM" | "SHORT" | "%future added value";
export type ConfluenceTone = "CONVERSATIONAL" | "PLAYFUL" | "PROFESSIONAL" | "SURPRISE" | "%future added value";
export type ConfluenceUpdateAudioPreferenceInput = {
  length?: ConfluenceLength | null | undefined;
  playbackSpeed?: number | null | undefined;
  tone?: ConfluenceTone | null | undefined;
};
export type useUpdateAudioPreferencesMutation$variables = {
  cloudId: string;
  input: ConfluenceUpdateAudioPreferenceInput;
};
export type useUpdateAudioPreferencesMutation$data = {
  readonly confluence_updateAudioPreference: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useUpdateAudioPreferencesMutation = {
  response: useUpdateAudioPreferencesMutation$data;
  variables: useUpdateAudioPreferencesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ConfluenceUpdateAudioPreferencePayload",
    "kind": "LinkedField",
    "name": "confluence_updateAudioPreference",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "ConfluenceUpdateAudioPreferencePayloadError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          },
          {
            "concreteType": "ConfluenceUpdateAudioPreferencePayloadErrorExtension",
            "kind": "LinkedField",
            "name": "extensions",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "statusCode"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useUpdateAudioPreferencesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUpdateAudioPreferencesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "a3949ed12b6ced04d34d02559d4db8de81e4d4cca0d32e35e9563ea54bb23de5",
    "metadata": {},
    "name": "useUpdateAudioPreferencesMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "b7870368cf8ebdcd82ca2559b27f7470";

export default node;
